import * as CONSTANTS from './constants';
import 'isomorphic-fetch';

export function alertMessage() {
    const alertMessageClass = '.alert-js';
    const alertCancelId = '.alert-close-js';
    const secondaryAlertMessageClass = '.secondary-alert-js';
    const secondaryAlertCancelId = '.secondary-alert-close-js';
    const showClass = 'alert-show';
    const body = document.querySelector('body');
    const header = document.querySelector('.header-top') as HTMLElement;
    const headerNavs = Array.prototype.slice.call(document.querySelectorAll('.header-nav'));
    const headerSearch = document.querySelector('.header-search') as HTMLElement;

    const alertMessageElements = Array.prototype.slice.call(document.querySelectorAll(alertMessageClass));
    const alertCancelElements = Array.prototype.slice.call(document.querySelectorAll(alertCancelId));
    const secondaryAlertMessageElements = Array.prototype.slice.call(document.querySelectorAll(secondaryAlertMessageClass));
    const secondaryAlertCancelElements = Array.prototype.slice.call(document.querySelectorAll(secondaryAlertCancelId));
    if (alertMessageElements != null && alertCancelElements != null) {
        setAlertMessageVisibility();
        alertCancelElements.forEach(element => {
            element.addEventListener('click', cancelAlert);
        });
    }

    if (secondaryAlertMessageElements != null && secondaryAlertCancelElements != null) {
        secondarySetAlertMessageVisibility();
        secondaryAlertCancelElements.forEach(element => {
            element.addEventListener('click', secondaryCancelAlert);
        });
    }

    if (
        alertMessageElements === null &&
        alertCancelElements === null &&
        secondaryAlertMessageElements === null &&
        secondaryAlertCancelElements === null
    ) {
        calcSiteHeaderHeight();
    }

    window.addEventListener('resize', () => {
        calcSiteHeaderHeight();
    });

    function calcSiteHeaderHeight() {
        const mobileBreakpoint = CONSTANTS.MOBILE_BREAKPOINT + 'rem';

        if (window.matchMedia(`(max-width: ${mobileBreakpoint})`).matches) {
            body.style.paddingTop = `${header.offsetHeight.toString()}px`;
            headerSearch.style.top = `${header.offsetHeight.toString()}px`;

            if (headerNavs) {
                headerNavs.forEach(nav => {
                    nav.style.top = `${header.offsetHeight.toString()}px`;
                });
            }
        }
    }

    function setAlertMessageVisibility() {
        if (window['ShouldDisplayPrimaryAlert'] && window['ShouldDisplayPrimaryAlert'].toLowerCase() == 'true') {
            alertMessageElements.forEach(element => {
                element.classList.add(showClass);
            });
        }
        calcSiteHeaderHeight();
    }

    function secondarySetAlertMessageVisibility() {
        if (window['ShouldDisplaySecondaryAlert'] && window['ShouldDisplaySecondaryAlert'].toLowerCase() == 'true') {
            secondaryAlertMessageElements.forEach(element => {
                element.classList.add(showClass);
            });
        }
        calcSiteHeaderHeight();
    }

    function cancelAlert() {
        fetch('/api/AlertMessageAPI/CloseMessage?isPrimary=true', {
            method: 'post',
            credentials: 'include'
        }).then(response => {
            if (response.ok) {
                alertMessageElements.forEach(element => {
                    element.classList.remove(showClass);
                });
                calcSiteHeaderHeight();
                return response;
            } else {
                // Failure case
                console.log(response);
            }
        });
    }

    function secondaryCancelAlert() {
        fetch('/api/AlertMessageAPI/CloseMessage?isPrimary=false', {
            method: 'post',
            credentials: 'include'
        }).then(response => {
            if (response.ok) {
                secondaryAlertMessageElements.forEach(element => {
                    element.classList.remove(showClass);
                });
                calcSiteHeaderHeight();
                return response;
            } else {
                // Failure case
                console.log(response);
            }
        });
    }
}
